import React, { useMemo } from 'react';

import { ReactRenderer } from '@atlaskit/renderer';
import { encodeAdf } from '@atlassian/conversation-assistant-content-renderer';

import type { MarkdownElement } from '../../dynamic-layout-parser/types/dynamic-layout-section';

export const DynamicLayoutMarkdown = ({ component }: { component: MarkdownElement }) => {
	const markdown = component.children?.[0] as string;

	const docContent = useMemo(() => (markdown ? encodeAdf(markdown, false) : undefined), [markdown]);
	return docContent ? <ReactRenderer document={docContent} /> : null;
};
